import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import { buildCustomIcons } from '@/styles/icons';
import { light, dark } from '@/styles/themes';

// @ts-ignore
import stobIcons from '@/styles/icons/svg';

import InsightMenuIcon from '@/styles/icons/components/InsightMenuIcon.vue';
import TagSlashIcon from '@/styles/icons/components/TagSlashIcon.vue';
import FigmaIcon from '@/styles/icons/components/FigmaIcon.vue';

Vue.use(Vuetify);

const customIcons = buildCustomIcons();

const mergedIcons = {
    ...customIcons,
    ...stobIcons,
    'insight-menu-icon': {
        component: InsightMenuIcon,
    },
    'tag-slash-icon': {
        component: TagSlashIcon,
    },
    'figma-icon': {
        component: FigmaIcon,
    },
};

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
        },
        themes: {
            light: light,
            dark: dark,
        },
    },
    breakpoint: {
        thresholds: {
            xs: 600,
            sm: 960,
            md: 1264,
            lg: 2504,
        },
        scrollBarWidth: 24,
    },
    icons: {
        values: mergedIcons,
    },
});

//Heck...
const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
// eslint-disable-next-line
Vue.config.warnHandler = function(msg, vm, trace) {
    // `trace` is the component hierarchy trace
    if (msg === ignoreWarnMessage) {
        msg = null;
        vm = null;
        trace = null;
    }
};
